import vidaMelhorImage from '../../assets/img/home/home-v2/home-section-vida-melhor.jpg'

export const vidaMelhorImagePath = vidaMelhorImage
